import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { responseObj } from '../../nest-model/nest-model';
import { NestApiProvider } from '../../nest-api';

@Injectable()
export class ContactSf6Provider {

  module: string = '';
  model: string = 'sf6s/contact';

  constructor(
    public http: HttpClient,
    public nestApi: NestApiProvider
  ) {
    console.log('Hello Contact SF6 Provider');
  }

  save(formData) {
    const method: string = "POST";
    const model: string = this.model;
    const func: string = "save";
    const params: any = formData || {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<responseObj<any>>(method, url, params, urlParams, body, contentType);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-integrated/services/contact-sf6.ts